import { EquipoXDivision, EquipoXDivisionJSON } from '../EquipoXDivision/EquipoXDivision';

export interface DivisionJSON {
  div_id: string | null;
  div_nombre: string;
  div_catid: string;
  div_es_promocional: boolean;
  div_activa: boolean;
  div_nivel_entrenador_minimo: number;
  div_fedid: string;
  div_divid_superior: string;
  div_rama: string;
  div_nivel_inferiores: string;
  equipoXDivisionList: EquipoXDivisionJSON[];
}

export interface Rama {
  key: string;
  text: string;
}

export class Division {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private catid: string,
    private esPromocional: boolean,
    private activa: boolean,
    private nivelEntrenadorMinimo: number,
    private fedid: string,
    private dividSuperior: string,
    private rama: string,
    private nivelInferiores: string,
    private equipoXDivisionList: EquipoXDivision[]
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    catid: string,
    esPromocional: boolean,
    activa: boolean,
    nivelEntrenadorMinimo: number,
    fedid: string,
    dividSuperior: string,
    rama: string,
    nivelInferiores: string,
    equipoXDivisionList: EquipoXDivision[]
  ) {
    return new this(
      id,
      nombre,
      catid,
      esPromocional,
      activa,
      nivelEntrenadorMinimo,
      fedid,
      dividSuperior,
      rama,
      nivelInferiores,
      equipoXDivisionList
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Division) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: DivisionJSON) {
    return Division.createFrom(
      entity.div_id,
      entity.div_nombre,
      entity.div_catid,
      entity.div_es_promocional,
      entity.div_activa,
      entity.div_nivel_entrenador_minimo,
      entity.div_fedid,
      entity.div_divid_superior,
      entity.div_rama,
      entity.div_nivel_inferiores,
      // entity.equipoXDivisionList
      entity.equipoXDivisionList ? entity.equipoXDivisionList.map((e) => EquipoXDivision.fromJSON(e)) : []
    );
  }

  toJSON(): DivisionJSON {
    return {
      div_id: this.getId(),
      div_nombre: this.getNombre(),
      div_catid: this.getCatid(),
      div_es_promocional: this.getEsPromocional(),
      div_activa: this.getActiva(),
      div_nivel_entrenador_minimo: this.getNivelEntrenadorMinimo(),
      div_fedid: this.getFedid(),
      div_divid_superior: this.getDividSuperior(),
      div_rama: this.getRama(),
      div_nivel_inferiores: this.getNivelInferiores(),
      equipoXDivisionList: this.getEquipoXDivisionList().map((e) => e.toJSON()),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getCatid(): string {
    return this.catid;
  }

  getEsPromocional(): boolean {
    return this.esPromocional;
  }

  getActiva(): boolean {
    return this.activa;
  }

  getNivelEntrenadorMinimo(): number {
    return this.nivelEntrenadorMinimo;
  }

  getFedid(): string {
    return this.fedid;
  }

  getDividSuperior(): string {
    return this.dividSuperior;
  }

  getRama(): string {
    return this.rama;
  }

  getNivelInferiores() {
    return this.nivelInferiores;
  }

  getEquipoXDivisionList(): EquipoXDivision[] {
    return this.equipoXDivisionList;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setCatid(value: string): void {
    this.catid = value;
  }

  setEsPromocional(value: boolean): void {
    this.esPromocional = value;
  }

  setActiva(value: boolean): void {
    this.activa = value;
  }

  setNivelEntrenadorMinimo(value: number): void {
    this.nivelEntrenadorMinimo = value;
  }

  setFedid(value: string): void {
    this.fedid = value;
  }

  setDividSuperior(value: string): void {
    this.dividSuperior = value;
  }

  setRama(value: string): void {
    this.rama = value;
  }
}
